import React, { useState } from 'react';
import {
  TableHead,
  TableRow,
  TableCell,
  Dialog,
  IconButton
} from '@material-ui/core';
import { DeleteRounded, AddCircle } from '@material-ui/icons';
import InlineTable from '@/module/common/component/InlineTable';
import TableCellFilted from '@/module/common/componentUI/TableCellFilted';
import AutocompleteModal from '@/module/common/component/AutocompleteModal';
import { ButtonEnhance } from '@/module/common/componentUI/commonStyleComponents';
import { testColumn } from '../constants';
import { TableWrapped } from '@/module/company/component/CompanyPaper/styled';
import servicesDispatcher from '@/module/services/action';
import styled from 'styled-components';

const TestsInformation = ({ formValue, setFormValue, disabled }) => {
  const [hiddenRows, setHiddenRows] = useState({});
  const [showModal, setShowModal] = useState(false);

  const onCloseModal = () => {
    setShowModal(false);
  };

  const onAddNewTest = data => {
    const lstTests = formValue.lstTests.concat(data);
    setFormValue({ ...formValue, lstTests });
    setShowModal(false);
  };

  const onDeleteTest = index => {
    let lstTests = [...formValue.lstTests];
    lstTests.splice(index, 1);
    setFormValue({ ...formValue, lstTests });
  };

  const TableCellFiltedWrapper = ({ ...props }) => (
    <TableCellFilted
      {...{
        hiddenRows,
        setHiddenRows
      }}
      {...props}
    />
  );
  const TableHeader = () => (
    <TableHead>
      <TableRow>
        {testColumn.map(item =>
          item.label ? (
            <TableCellFiltedWrapper
              key={item.stateValue}
              label={item.label}
              stateValue={item.stateValue}
            />
          ) : (
            <TableCell key={item.stateValue}></TableCell>
          )
        )}
      </TableRow>
    </TableHead>
  );
  const TableFooter = () =>
    disabled ? null : (
      <StyledButtonEnhance
        background="#EFDFEB"
        color="#AD5E99"
        backgroundHover="#EFDFEB"
        onClick={() => setShowModal(true)}
      >
        <div className="add-group">
          <span>Add new test</span>
          <AddCircle />
        </div>
      </StyledButtonEnhance>
    );

  const renderRow = onDeleteTest => (row, i, onDeleteValue) => (
    <>
      <TableCell>{!hiddenRows.test && row.name}</TableCell>
      <TableCell>{!hiddenRows.labCode && row.labHeader}</TableCell>
      {/* <TableCell>{!hiddenRows.mincCode && row.mincCode}</TableCell> */}
      <TableCell>{!hiddenRows.station && row.stationName}</TableCell>
      <TableCell align="right">
        {!disabled && (
          <IconButton
            className="delete-icon"
            onClick={() => (onDeleteTest ? onDeleteTest(i) : onDeleteValue(i))}
          >
            <DeleteRounded />
          </IconButton>
        )}
      </TableCell>
    </>
  );

  return (
    <TableWrapped>
      <InlineTable
        Header={TableHeader}
        data={formValue.lstTests}
        Footer={TableFooter}
        noDataHelperText={
          disabled ? 'No data' : 'Click button "Add new test" to create new one'
        }
        renderRow={renderRow(onDeleteTest)}
      />
      <Dialog maxWidth="lg" open={showModal} onClose={onCloseModal}>
        <AutocompleteModal
          onClose={onCloseModal}
          title="Tests"
          optionLabel="name"
          textFieldPlaceholder="Select test"
          onSubmit={onAddNewTest}
          Header={TableHeader}
          renderRow={renderRow()}
          getListOptions={callback =>
            servicesDispatcher.getAllServices('Tests', callback)
          }
          existedOption={formValue.lstTests}
        />
      </Dialog>
    </TableWrapped>
  );
};

export const StyledButtonEnhance = styled(ButtonEnhance)`
  display: flex;
  justify-content: center;
  max-width: 160px;
  float: right;
  margin-top: 15px;
  height: 35px;
  padding: 8px 16px;
  .add-group {
    display: flex;
    width: fit-content;
    align-items: center;
    margin-top: -2px;
    span {
      margin-right: 8px;
    }
  }
`;

export default TestsInformation;
